import React from 'react';
import { Link } from 'react-router-dom';

const CallToAction = () => {
  return (
    <section id='cta' className='bg-gray-700'>
      {/* Flex Container */}
      <div className='container flex flex-col items-center justify-between px-6 py-24 mx-auto space-y-12 md:py-12 md:flex-row md:space-y-0'>
        {/* Heading */}
        <h2 className='text-5xl font-bold leading-tight text-center text-white md:text-4xl md:max-w-xl md:text-left'>
        Thousands of People Are Now Using Ajo. Join Our Community!
        </h2>
        {/* Button */}
        <div>
          <Link
            to='/register'
            className='p-3 px-6 pt-3 bg-white rounded-full shadow-2xl baseline hover:bg-gray-900 hover:text-white text-gray-900 transition duration-300'
          >
            Get Started
          </Link>
        </div>
      </div>
    </section>
  );
};

export default CallToAction;